import React from 'react';

const LoadingSpinner = ({ size = "large" }) => {
  const sizeClasses = {
    small: "h-8 w-8",
    medium: "h-16 w-16",
    large: "h-32 w-32"
  };
  
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className={`animate-spin rounded-full ${sizeClasses[size]} border-t-2 border-b-2 border-white`}></div>
    </div>
  );
};

export default LoadingSpinner;